import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

function FormInlineSelect({
  name,
  label,
  onChange,
  value,
  placeholder,
  options,
  sm,
  ...props
}) {
  const handleChange = ({ target }) => {
    onChange((state) => ({
      ...state,
      [name]: target.value,
    }));
  };
  return (
    <div className="flex rounded-md shadow-primary-sm">
      <div className="relative flex items-stretch flex-grow focus-within:z-10">
        {label && (
          <div className="absolute text-gray-500 font-medium inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {label}
          </div>
        )}
        <select
          autoComplete="none"
          className={cn(
            'form-select block w-full text-base text-gray-500 border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md overflow-ellipsis overflow-hidden',
            sm ? 'py-1' : 'py-2',
            label ? 'pl-16 text-right' : 'pl-2'
          )}
          onChange={handleChange}
          value={value}
          {...props}
        >
          {placeholder && <option value="">{placeholder}</option>}
          {options.map((x) => (
            <option label={x.label} value={x.value} key={x.value}>
              {x.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}

FormInlineSelect.defaultProps = {
  placeholder: '',
  options: [],
  sm: false,
  label: 'Select',
};

FormInlineSelect.propTypes = {
  options: PropTypes.instanceOf(Array),
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  sm: PropTypes.bool,
  label: PropTypes.string,
};

export default FormInlineSelect;
